import * as React from 'react';

import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';

import {AiGeneratingState} from './ai-generating-state';

import styles from './ai-design-page.module.css';

const FULL_STATUS_MESSAGES = [
    "Grabbing your brand's logo and colors…",
    'Scraping website content and choosing the right tone…',
    'Finding images to highlight your message…',
    'Cooking up a beautiful looking template…',
    'Drafting compelling message content…',
    'Applying your company’s unique style…',
    'Polishing layouts and adding vibrant visuals…',
    'Finalizing some details and checking our work…',
];

const REGENERATE_STATUS_MESSAGES = [
    'Cooking up a beautiful looking template…',
    'Drafting compelling message content…',
    'Applying your company’s unique style…',
    'Polishing layouts and adding vibrant visuals…',
    'Finalizing some details and checking our work…',
];

const ROTATION_INTERVAL_MS = 10000;

type Props = {
    isRegenerating: boolean;
};

export function AiGeneratingStatus(props: Props) {
    const {isRegenerating} = props;

    const messages = isRegenerating ? REGENERATE_STATUS_MESSAGES : FULL_STATUS_MESSAGES;
    const [currentIndex, setCurrentIndex] = React.useState(0);

    // Reset index when isRegenerating changes
    React.useEffect(() => {
        setCurrentIndex(0);
    }, [isRegenerating]);

    // Rotate through messages, stopping at the last one
    React.useEffect(() => {
        const isLastMessage = currentIndex >= messages.length - 1;

        if (isLastMessage) {
            return;
        }

        const timer = setTimeout(() => {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }, ROTATION_INTERVAL_MS);

        return () => clearTimeout(timer);
    }, [currentIndex, messages.length]);

    const currentMessage = messages[currentIndex];

    return (
        <div className={styles['generating-container']}>
            <div className={styles['generating-text']}>
                <span className={styles['generating-text-animated']}>{currentMessage}</span>
                <AiSparkleNewIcon size={16} />
            </div>
            <AiGeneratingState />
        </div>
    );
}
